module.exports = __webpack_public_path__ + "img/Bodice-Back-Ja-Kg-Lb.44715114.png";